'use client';

import Link from 'next/link';
import { useCookieConsent } from './CookieConsentProvider';
import { CookiePreferencesModal } from './CookiePreferencesModal';

export function CookieBanner() {
  const { consent, isReady, acceptAll, rejectNonEssential, openPreferences } = useCookieConsent();

  return (
    <>
      {isReady && !consent && (
        <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
          <div className="cookie-banner__inner">
            <p className="cookie-banner__text">
              We use essential cookies for sign-in, your theme, and to remember your choices. With
              your permission, we also use optional analytics cookies. See our{' '}
              <Link href="/legal/cookies/">Cookie Policy</Link>.
            </p>
            <div className="cookie-banner__actions">
              <button type="button" className="btn btn-ghost" onClick={rejectNonEssential}>
                Reject non-essential
              </button>
              <button type="button" className="btn btn-ghost" onClick={openPreferences}>
                Manage preferences
              </button>
              <button type="button" className="btn btn-primary" onClick={acceptAll}>
                Accept all
              </button>
            </div>
          </div>
        </div>
      )}
      <CookiePreferencesModal />
    </>
  );
}
